import React, { useState } from "react";
import { Navbar, Container, Modal, Button } from "react-bootstrap";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import img1 from "../assets/images/logo colegio (32).png";

function NavigationBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [menuAbierto, setMenuAbierto] = useState(false);

  const handleLogoutConfirm = () => {
    setShowModal(false);
    setMenuAbierto(false);
    localStorage.clear();
    navigate("/login");
  };

  const cerrarMenu = () => setMenuAbierto(false);

  return (
    <>
      <Navbar
        bg="dark"
        variant="dark"
        sticky="top"
        className="shadow-sm px-3 portal-nav"
      >
        <Container fluid className="portal-nav-shell">
          <button
            type="button"
            className="portal-nav-brand"
            onClick={() => navigate("/inicio")}
          >
            <img src={img1} alt="logo" style={{ width: 40 }} />
          </button>

          <div className="portal-hamburger-wrap">
            <button
              type="button"
              className="portal-hamburger-btn"
              onClick={() => setMenuAbierto((prev) => !prev)}
              aria-expanded={menuAbierto}
              aria-label="Abrir menú del portal"
            >
              <span className="portal-hamburger-icon">
                <span />
                <span />
                <span />
              </span>
              <span className="portal-hamburger-text">Menú</span>
            </button>

            {menuAbierto && (
              <div className="portal-hamburger-menu shadow-lg">
                <NavLink
                  to="/inicio"
                  className={`portal-hamburger-link ${
                    location.pathname.startsWith("/inicio") ? "active" : ""
                  }`}
                  onClick={cerrarMenu}
                >
                  Inicio
                </NavLink>

                <NavLink
                  to="/facturas"
                  className={`portal-hamburger-link ${
                    location.pathname.startsWith("/facturas") ? "active" : ""
                  }`}
                  onClick={cerrarMenu}
                >
                  Facturas
                </NavLink>

                <NavLink
                  to="/configuracion"
                  className={`portal-hamburger-link ${
                    location.pathname.startsWith("/configuracion") ? "active" : ""
                  }`}
                  onClick={cerrarMenu}
                >
                  Configuración
                </NavLink>

                <button
                  type="button"
                  className="portal-hamburger-link portal-hamburger-link-danger"
                  onClick={() => {
                    cerrarMenu();
                    setShowModal(true);
                  }}
                >
                  Salir
                </button>
              </div>
            )}
          </div>
        </Container>
      </Navbar>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>¿Confirmar salida?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ¿Estás seguro que querés salir de tu sesión? Se cerrará tu acceso actual.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={handleLogoutConfirm}>
            Sí, salir
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default NavigationBar;
